function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8C9BA8",
  d: "M168.856241,7.0015497 C166.076208,7.03673971 163.831202,9.25654462 163.795612,12.0053703 C163.808347,13.1043181 164.168226,14.1718355 164.824892,15.058549 L160.193131,19.8079381 C159.935623,20.0994048 159.935623,20.5341976 160.193131,20.8256643 C160.330046,20.9560232 160.519135,21.0183454 160.707771,20.9952853 C160.906973,20.9824718 161.092523,20.8907383 161.222411,20.7408538 L166.02572,15.9914647 C166.873046,16.6005914 167.894417,16.9273257 168.942014,16.9243804 C170.754543,16.9384458 172.433897,15.9850229 173.335348,14.4301456 C174.236798,12.8752683 174.220247,10.9605837 173.29205,9.42116885 C172.363852,7.88175401 170.668262,6.95685302 168.856241,7.0015497 Z M168.856241,15.7370332 C166.796336,15.7118856 165.146064,14.0421915 165.167986,12.0053703 C165.176497,9.98075408 166.809376,8.32865743 168.856241,8.27370749 C170.916146,8.29885504 172.566417,9.9685492 172.544496,12.0053703 C172.569986,12.9878604 172.192406,13.9387569 171.497687,14.6416523 C170.802967,15.3445478 169.850208,15.7396473 168.856241,15.7370332 Z",
  transform: "translate(-160 -7)"
});

function SvgIconSearchSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchSmall);
export default __webpack_public_path__ + "static/media/icon_search_small.463d7625.svg";
export { ForwardRef as ReactComponent };